export default function CustomButton({ children, href, ...props }) {
  const Component = href
    ? ({ children, ...restProps }) => (
        <a href={href} {...restProps} {...props}>
          {children}
        </a>
      )
    : ({ children, ...restProps }) => (
        <button {...restProps} {...props}>
          {children}
        </button>
      );

  return <Component>{children}</Component>;
}
